module.exports = __webpack_public_path__ + "img/banner1.12f7a94a.jpg";